import localStorage from 'mobx-localstorage';

export type StorageModel = typeof localStorage;
export const StorageModel = localStorage;